// extracted by mini-css-extract-plugin
module.exports = {"copiedToast":"Share_copiedToast__JUF_e"};